import client, { PRIVATE_CLIENT } from '../../services/client';
import sessionStore from '../../store/session';

export const getProfileAction = async () => {
    const response = await client.get('users/me/', PRIVATE_CLIENT);

    const { personal_email: email, first_name, last_name, receivers, balance } = response

    const profile = {
        email,
        full_name: `${first_name} ${last_name}`,
    };
    
    sessionStore.setProfile(profile);
    sessionStore.setBalance(balance);
    sessionStore.setReceivers(receivers)
};
